"use strict";

angular.module("core").controller("TermsOfServiceModalController", function($scope, close) {
    $scope.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/terms-of-service/terms-of-service-agreement/terms-of-service.modal.js
// module id = 554
// module chunks = 0